export { AtnDsTextComponent as Component } from './text.component'
